import type { ShipmentColumn } from '../../types/column-types'
import Status from '../../components/cells/status/status'
import { onCellStandard } from '../../helpers/helpers'
import type { DataSourceItem } from '../../shipments-page'

export const statusColumn: ShipmentColumn = {
    key: 'status',
    dataIndex: 'status',
    title: '',
    width: 68,
    // Заголовок — кнопка групповых операций (см. shipments-page), в «Колонки» не выводим
    hideInColumnManager: true,
    onCell: onCellStandard,
    render: (_v, record: DataSourceItem) => <Status data={record} />,
}

